import React from "react";
import { connect } from "react-redux";
import { BrowserRouter, Route, Redirect, Switch } from "react-router-dom";

import IssuerLayout from "layouts/Issuer";
import PublicLayout from "layouts/Public";
import { withLang } from "managers/routeManager";

const App = ({ account }) => {
  const state = { account };

  return (
    <BrowserRouter>
      <Switch>
        <Route
          path="/:lang/issuer"
          render={(props) => <IssuerLayout {...props} />}
        />

        <Route
          path="/:lang/public"
          render={(props) => <PublicLayout {...props} />}
        />

        <Redirect from="/issuer" to={withLang(state, "/issuer/dashboard")} />
        <Redirect from="/public" to={withLang(state, "/public/user/auth")} />

        <Redirect from="/" to={withLang(state, "/issuer/dashboard")} />
      </Switch>
    </BrowserRouter>
  );
};

function mapStateToProps(state) {
  const { account, terms } = state;

  return {
    account,
    terms,
  };
}

export default connect(mapStateToProps)(App);
